<template>
<div
      class="categories"
      v-if="categories">
      <p>Type de projet :</p>
      <div>
        <button class="category-btn" @click="redirectToProjects(cat.slug,cat.description)"
      v-for="cat in categories"
      :key="cat.id">
      <i :class="cat.slug"></i>
      {{cat.name}}
    </button>
      </div>
      </div>
</template>
<script setup lang='ts'>
import type { Category } from '~/types/projects';


 const props = defineProps<{
    categories:Category[]
}>()
const store = useFiltersStore()
const redirectToProjects = (slug:string,description:string) => {
  store.setFilter(slug,description)
  navigateTo('/projets')
}
</script>

<style lang="scss">
    .categories{
      display: flex; 
      align-items: center;
      margin-bottom: 10px;
      p{
        margin-bottom: 0 !important;
       min-width: 130px;
       @media screen and (max-width:1035px) {
        min-width: auto;
       }
      }
    .category-btn{
      font-size: 14px;
      color: $text_light;
      font-weight: 600;
      border:none;
      background-color: transparent;
      cursor: pointer;
      &:not(:last-child){
        margin-right: 4px;
      }
      @media screen and (max-width:1035px) {
        font-size: 12px;
        font-weight: 500;
        margin-left: 10px;
      }
      i{
        width: 12px;
        height: 12px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        display: inline-flex;
        &.habillage-de-documentaire{
          background-image: url("~/assets/svgs/picto-habillage.svg");
        }
        &.illustration{
          background-image: url("~/assets/svgs/picto-illustration.svg");
        }
        &.motion{
          background-image: url("~/assets/svgs/picto-motion.svg");
        }
        &.graphisme{
          background-image: url("~/assets/svgs/picto-culture-expo.svg");
        }
      }
    
    }
  }
</style>